import { plaintextValidator } from '../fields';

const config = { mandatory: true };

const STARTSWITH_HTTPS_PATTERN = /^(http|https):\/\/(.*)/;

export default {
  cwcURL: {
    ...plaintextValidator(config),
    format: {
      pattern: STARTSWITH_HTTPS_PATTERN,
      message: '^ConnectWise Control URL should start with https://'
    }
  },
  instanceId: plaintextValidator(config),
  sessionGroup: plaintextValidator(config)
};
